import Config from '@configs/Environments';

const useMockServer:boolean = (Config.API_END_POINT.match(/http:\/\/127\.0\.0\.1/));
// const useMockServer:boolean = false;

export default useMockServer;